export default {
    metaWhatsappAuth:       null,
    metaWhatsappConnecting: false,
    metaWhatsappError:      null,
}


// WEBPACK FOOTER //
// ./src/modules/metaWhatsappApi/state.js